import { render, staticRenderFns } from "./CardPopup.vue?vue&type=template&id=3fa47e90"
import script from "./CardPopup.vue?vue&type=script&lang=js"
export * from "./CardPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports